module.exports = __webpack_public_path__ + "img/x-circle.a50989aa.svg";